import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sheet__title"
}


interface BaseSheetProps {
  tagName: string;
  title?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSheet',
  props: {
    tagName: { default: "div" },
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tagName), { class: "sheet" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        (__props.title)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(__props.title), 1))
          : _createCommentVNode("", true)
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})